module.exports = __webpack_public_path__ + "static/img/handle0.d0c9fac9.png";